import script from "./GenericBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericBadge.vue?vue&type=script&setup=true&lang=js"

import "./GenericBadge.vue?vue&type=style&index=0&id=57ddad1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ddad1c"]])

export default __exports__